import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from 'scripts/hooks/context/use-app-context';
import { RepurchaseItem } from './item';

interface PackageRepurchaseProps {
  mostRecentPackage: any;
  upsellPackage: any;
}

export const PackageRepurchase: React.FC<PackageRepurchaseProps> = ({
  mostRecentPackage,
  upsellPackage,
}) => {
  const { t, ready: translationLoaded } = useTranslation('self-service/packages/repurchase');

  // track views
  const { analyticsContext } = useAppContext();
  useEffect(() => {
    if (mostRecentPackage) {
      analyticsContext?.trackEvent({
        action: 'recommended-packages-loaded',
        category: 'tutoring-packages',
      });
    }
  }, [analyticsContext, mostRecentPackage]);

  if (!mostRecentPackage || !translationLoaded) {
    return null;
  }

  return (
    <div className="repurchase-wrapper">
      <h5>{t('title')}</h5>
      <RepurchaseItem packageData={mostRecentPackage} />
      {upsellPackage && <RepurchaseItem upsell packageData={upsellPackage} />}
    </div>
  );
};
